import { ContentChildren, Directive, QueryList } from '@angular/core';
import { ValidationErrorMessageComponent } from './validation-error-message.component';

@Directive({
  selector: '[ngc-error-handler-helper]',
  exportAs: 'ngcErrorHanglerDirective'
})
export class ErrorHandlerHelperDirective {
  @ContentChildren(ValidationErrorMessageComponent, { descendants: true })
  errorMessageComponents: QueryList<ValidationErrorMessageComponent>;

  constructor() {}

  public getAllErrorMessageComponents() {
    const errorMessageComponents: ValidationErrorMessageComponent[] = [];
    const ecs = this.errorMessageComponents.toArray();
    for (const ec of ecs) {
      errorMessageComponents.push(ec);
    }
    return errorMessageComponents;
  }
}
